import { render, staticRenderFns } from "./AttendanceRegistrationFields.vue?vue&type=template&id=627cf464&scoped=true"
import script from "./AttendanceRegistrationFields.vue?vue&type=script&lang=js"
export * from "./AttendanceRegistrationFields.vue?vue&type=script&lang=js"
import style0 from "./AttendanceRegistrationFields.vue?vue&type=style&index=0&id=627cf464&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627cf464",
  null
  
)

export default component.exports